<ntap-prime-growl></ntap-prime-growl>
<router-outlet></router-outlet>
<p-confirmDialog #cd width="425" appendTo="body" key="order-popup">
    <ng-template pTemplate="footer">
        <button type="button" pButton icon="pi pi-times" label="Odustani" (click)="cd.reject()"></button>
        <button type="button" pButton icon="pi pi-check" label="Potvrdi" (click)="cd.accept()"></button>
    </ng-template>
</p-confirmDialog>
<app-file-upload-progress-toast />
<ntap-prime-global-spinner></ntap-prime-global-spinner>